// Block plus notation (name+tag@example.com) in Core dna Forms module email fields,
// so one inbox can't generate unlimited competition, presale and waitlist entries.
//
// Scoped to forms that render a _formId input — the marker the Forms module always
// emits — because login, forgot-password and the sign-in modal do NOT carry it. That
// keeps existing members whose account email contains a "+" able to sign in as normal.
// The registration form has its own equivalent check in templates/users/register.html.
//
// Capture-phase listener runs before bubble-phase jQuery submit handlers, so AJAX
// submissions ($form.serialize()) are blocked too.

// Importing this first is deliberate: ES modules evaluate their dependencies before
// their own body, so form-submit-lock registers its submit listener before ours. Its
// listener therefore runs first and takes the lock, and the setTimeout we schedule
// below lands after the one it schedules -- which is what lets us release it.
import { release } from './form-submit-lock';

const ERROR_CLASS = 'js-no-plus-error';
const ERROR_TEXT = 'Please enter an email address that does not contain a "+".';

function isFormsModuleForm(form) {
	return form instanceof HTMLFormElement
		&& form.querySelector('input[name="_formId"]') !== null;
}

// Each message is tied to its own input. Forms can render two email fields as
// siblings (email + confirm), so looking the message up by parent would let a
// valid field delete the message belonging to an invalid one.
const messages = new WeakMap();

function clearError(input) {
	input.classList.remove('is-invalid');
	const existing = messages.get(input);
	if (existing) {
		existing.remove();
		messages.delete(input);
	}
}

function showError(input) {
	clearError(input);
	input.classList.add('is-invalid');
	const message = document.createElement('div');
	message.className = `${ERROR_CLASS} text-danger mt-1`;
	message.textContent = ERROR_TEXT;
	input.insertAdjacentElement('afterend', message);
	messages.set(input, message);
}

export function validateNoPlus(form) {
	if (!isFormsModuleForm(form)) {
		return true;
	}

	let firstInvalid = null;
	form.querySelectorAll('input[type="email"]').forEach((input) => {
		if (input.value.includes('+')) {
			showError(input);
			if (!firstInvalid) {
				firstInvalid = input;
			}
		} else {
			clearError(input);
		}
	});

	if (firstInvalid) {
		firstInvalid.focus();
		return false;
	}
	return true;
}

document.addEventListener('submit', (event) => {
	if (validateNoPlus(event.target)) {
		return;
	}

	const form = event.target;

	event.preventDefault();
	event.stopPropagation();

	// form-submit-lock defers its decision to the end of the current task. A submit
	// that was cancelled with no request sent normally means "validation said no",
	// and it undoes the lock -- but on a form carrying an invisible reCAPTCHA it
	// cannot tell that apart from a challenge in progress, so it holds the button in
	// its spinner state for two minutes instead. Every competition, waitlist and
	// microsite form has one, so release it explicitly and give the visitor a live
	// button to correct the address and resubmit.
	setTimeout(() => release(form), 0);
}, true); // capture phase

// Clear the message as soon as the visitor removes the "+".
document.addEventListener('input', (event) => {
	const input = event.target;
	if (input instanceof HTMLInputElement && input.type === 'email' && !input.value.includes('+')) {
		clearError(input);
	}
});
